import styled from 'styled-components';
import { BaseContainer } from '../../BaseContainer/BaseContainer';
export const Container = styled(BaseContainer).withConfig({ displayName: "vui--Container", componentId: "vui--r1m0qe" }) `display:inline-flex;background-color:#ffffff;box-shadow:1px 4px 15px rgba(27, 33, 38, 0.25);border-radius:4px;overflow:hidden;`;
//# sourceMappingURL=styled.js.map